import { directive as vClickOutside } from '../node_modules/vue-clickaway';
import qs from 'qs';
// import Vuex from "vuex";

/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

const GlobalDirectives = {
    install (Vue) {
        Vue.directive('click-outside', vClickOutside);
        Vue.mixin({
            methods: {

                // can: (key) => localStorage.getItem('permissions').includes(key)
                can (key) {
                    let permissions = this.$store.getters['profile/permissions'];
                    return permissions.includes(key);
                },
                isStaff () {
                    let modelType = this.$store.getters['profile/me'] ? this.$store.getters['profile/me'].model_type : null;
                    return modelType === 'Staff';
                },
                role (key) {
                    let roles = this.$store.getters['profile/roles'];
                    if (roles.length < 1) {
                        return roles.includes(key);
                    }
                },
                requestParams (id)  {
                    let options;
                    let idType = typeof (id);
                    if (idType !== 'object') {
                        options = {
                            headers: {
                                'Accept': 'application/vnd.api+json',
                                'Content-Type': 'application/vnd.api+json',
                            }
                        };
                    } else {
                        options = {
                            headers: {
                                'Accept': 'application/vnd.api+json',
                                'Content-Type': 'application/vnd.api+json',
                            },
                            params: id,
                            paramsSerializer: function (params) {
                                return qs.stringify(params, { encode: false });
                            },
                        };
                        id = id.id;
                    }
                    return { options:options,id:id };
                }
            }
        });
    }
};

export default GlobalDirectives;
